import React from 'react';

const StarIcon: React.FunctionComponent = () => {
  return (
    <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6894_109309)">
        <path
          d="M12.1441 1.17143L8.38433 5.45714L14.5128 4.77143V7.11429L8.27154 6.54286L12.0313 10.6571L9.47467 11.9143L7.1812 7.17143L4.47415 12L2.14308 10.7714L5.90287 6.57143L0 7.17143V4.82857L5.97807 5.48571L2.14308 1.22857L4.62454 0L7.1436 4.8L9.70026 0L12.1441 1.17143Z"
          fill="#111111"/>
      </g>
      <defs>
        <clipPath id="clip0_6894_109309">
          <rect width="14.4" height="12" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default StarIcon;